<template>
  <div class="invoice">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>确认发票</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
    </div>

    <div class="invoice-content">
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="150"
        @submit.native.prevent
      >
        <div class="invoice-tip" v-if="invoiceDownInfo && editStatus">
          您于{{invoiceDownInfo.changeTime | moment("YY/MM/DD HH:mm:ss")}} 提交的修改，尚未审核
          <!-- <span v-if="invoiceDownInfo.status === 1">审核通过</span> <span v-if="invoiceDownInfo.status === -1">审核未通过</span> -->
          <span style="color: #1890ff;margin-left:10px;" @click="$router.push('/exhibition/index/exinfo/invoice-alter')">查看我的修改</span>
        </div>
        <p style="padding-left: 150px;color: #ff0000;line-height: 34px;">请保证您填写的发票信息正确无误</p>
        <FormItem label="发票抬头：" prop="Title">
          <Input type="text" style="width:600px;" v-model="formInline.Title" :disabled="invoiceDownInfo && editStatus?true:false" placeholder="请输入您营业执照上的全称" />
        </FormItem>
        <FormItem label="税务登记证号：" prop="Code">
          <Input type="text" style="width:600px;" v-model="formInline.Code" :disabled="invoiceDownInfo && editStatus?true:false" placeholder="请输入15到20位有效纳税人识别号" />
          <p
            style="font-size: 14px;color: #808080;line-height: initial;padding-top:5px;"
          >请与贵公司财务人员核实后，仔细填写准确的三证合一后的社会统一信用代码或税务登记证号，否则将影响后续发票的正常使用</p>
        </FormItem>
        <FormItem label="开户银行名称：" prop="BankName">
          <Input type="text" style="width:600px;" v-model="formInline.BankName" :disabled="invoiceDownInfo && editStatus?true:false" placeholder="请输入您开户许可证上的开户银行" />
        </FormItem>
        <FormItem label="开户银行账号：" prop="BankNumber">
          <Input type="text" style="width:600px;" v-model="formInline.BankNumber" :disabled="invoiceDownInfo && editStatus?true:false" placeholder="请输入您开户许可证上的银行账号" />
        </FormItem>
        <FormItem label="注册场所地址：" prop="Address">
          <Input type="text" style="width:600px;" v-model="formInline.Address" :disabled="invoiceDownInfo && editStatus?true:false" placeholder="请输入您营业执照上的注册地址" />
        </FormItem>
        <FormItem label="注册固定电话：" prop="Tel">
          <Input type="text" style="width:600px;" v-model="formInline.Tel" :disabled="invoiceDownInfo && editStatus?true:false" placeholder="请输入您公司有效的联系电话" />
        </FormItem>
        <FormItem v-if="!editStatus">
          <Button
            type="primary"
            size="large"
            :loading="loading"
            @click="handleSubmit('formInline')"
            style="width: 154px;"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import config from '@assets/config.json';

export default {
  name: "company-info-auth",
  data() {
    return {
      invoiceInfoIsHave: false, // 判断开票信息为新增or编辑
      invoiceInfo: null,
      invoiceDownInfo: null,
      loading: false,

      formInline: {
        // form双向绑定
        Title: "", // 发票抬头
        // InvoiceType: "1", // 1:企业增值税普通发票 2:增值税专用发票
        Code: "", // 税务登记证号(纳税人识别号)
        BankName: "", // 开户银行名称
        BankNumber: "", // 开户银行账号
        Address: "", // 注册场所地址
        Tel: "" // 注册固定电话
      },
      ruleInline: {
        // 效验规则
        Title: [{ required: true, message: "发票抬头", trigger: "blur" }],
        Code: [
          {
            required: true,
            message: "税务登记证号(纳税人识别号)不能为空",
            trigger: "blur"
          },
          {
            type: "string",
            min: 15,
            message: "税务登记证号小于15位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 20,
            message: "税务登记证号大于20位",
            trigger: "blur"
          }
        ],
        BankName: [
          { required: true, message: "开户银行名称不能为空", trigger: "blur" }
        ],
        BankNumber: [
          { required: true, message: "开户银行账号不能为空", trigger: "blur" }
        ],
        Address: [
          { required: true, message: "注册场所地址不能为空", trigger: "blur" }
        ],
        Tel: [{ required: true, message: "固定电话不能为空", trigger: "blur" }]
      },
      editStatus: false,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      invoiceAlter: "companyInfoModule/getInvoiceAlter",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  created() {
    document.title = "国际焙烤展 - 确认发票";
    this.init();
  },
  methods: {
    ...mapActions({
      getInvoice: "exhibitionModule/getInvoice",
      getInvoiceDown: "exhibitionModule/getInvoiceDown",
      submitInvoice: "exhibitionModule/submitInvoice",
      submitInvoiceDown: "exhibitionModule/submitInvoiceDown",
    }),
    ...mapMutations({
      setInvoiceAlter: "companyInfoModule/setInvoiceAlter"
    }),
    async init() {
      // 获取发票信息
      let res = await this.getInvoice(this.company.id);
      if (res) {
        this.invoiceInfoIsHave = true;
        this.invoiceInfo = res;
        this.formInline.Title = res.title;
        this.formInline.Code = res.code;
        this.formInline.BankName = res.bank;
        this.formInline.BankNumber = res.bankAccount;
        this.formInline.Address = res.address;
        this.formInline.Tel = res.tel;
      }

      // 获取发票修改记录
      let result = await this.getInvoiceDown(this.joinInfo.joinId);
      if (result) {
        this.invoiceDownInfo = result;
        console.log(result,'ressssssssssssssss')

        // if (this.invoiceDownInfo.syncStatus === 2 && this.invoiceDownInfo.status === 1) {
          if (this.invoiceDownInfo.syncStatus === 2) {
          this.editStatus = false;
            }
        else{
            this.editStatus = true;

            this.formInline.Title=this.invoiceDownInfo.title
            this.formInline.Code=this.invoiceDownInfo.code
            this.formInline.BankName=this.invoiceDownInfo.bank
            this.formInline.BankNumber=this.invoiceDownInfo.bankAccount
            this.formInline.Address=this.invoiceDownInfo.address
            this.formInline.Tel=this.invoiceDownInfo.tel
          }
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit(name) {
      let valid = await this.validForm("formInline");
      if (!valid) return;
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      if (this.invoiceInfoIsHave) {
        this.editSubmit();
      } else {
        this.addSubmit();
      }
    },

    async editSubmit() {
      let form = this.formInline;
      const req = {
        Id: this.invoiceInfo.id,
        ExhibitonId: this.exhibitionId,
        JoinId: this.joinInfo.joinId,
        CommandId: 2,// "CommandId说明":"1：新增，2：修改，3：删除",
        SetValues: {
          Title: form.Title,
          Code: form.Code,
          Address: form.Address,
          Tel: form.Tel,
          BankAccount: form.BankNumber,
          Bank: form.BankName
        }
      };
      const bool = await this.submitInvoiceDown(req);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("保存成功，请等待审核");
        this.init();
      } else {
        this.loading = false;
        this.$Message.warning(`保存失败，请重试`);
      }
    },
    async addSubmit() {
      let form = this.formInline;
      const req = {
        ExhibitonId: this.exhibitionId,
        JoinId: this.joinInfo.joinId,
        CommandId: 1,// "CommandId说明":"1：新增，2：修改，3：删除",
        SetValues: {
          CompId: this.joinInfo.compId,
          Title: form.Title,
          Code: form.Code,
          Address: form.Address,
          Tel: form.Tel,
          Bank: form.BankName,
          BankAccount: form.BankNumber,
        },
      };
      const bool = await this.submitInvoice(req);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("保存成功，请等待审核");
        this.init();
      } else {
        this.loading = false;
        this.$Message.warning(`保存失败，请重试`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.invoice {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
  .invoice-tip {
    line-height: 34px;
    padding-left: 150px;
    color: #ff0000;
    span {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
